<template>
  <div>
    <v-layout v-for="(item, index) in table" :key="index" class="pa-1">
      <div
        style="width: 40%;"
        :style="{ 'font-weight': weightText(item.current) }"
      >{{getDayOfWeek(item.day)}}</div>
      <div style="width: 60%;" :style="{ 'font-weight': weightText(item.current) }">
        <v-layout v-if="item.hours.length === 0" justify-end>-</v-layout>
        <v-layout v-else v-for="(hour, i) in item.hours" :key="i" justify-end>{{formatRange(hour)}}</v-layout>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { formatRange } from '@/lib/helpers/HoursFormatter.js'
import moment from 'moment'
export default {
  props: {
    timetable: Array,
  },
  created () {
    moment.locale(this.$i18n.locale)
  },
  methods: {
    formatRange (hour) {
      return formatRange(hour)
    },
    getDayOfWeek (day) {
      if (day === 0) {
        return this.$t('activities.dow.sunday')
      } else if (day === 1) {
        return this.$t('activities.dow.monday')
      } else if (day === 2) {
        return this.$t('activities.dow.tuesday')
      } else if (day === 3) {
        return this.$t('activities.dow.wednesday')
      } else if (day === 4) {
        return this.$t('activities.dow.thursday')
      } else if (day === 5) {
        return this.$t('activities.dow.friday')
      } else if (day === 6) {
        return this.$t('activities.dow.saturday')
      }
    },
    weightText (isCurrent) {
      if (isCurrent) {
        return 'bold'
      } else return 'normal'
    },
  },
  computed: {
    weekdays () {
      var wd = []
      for (let index = moment.localeData().firstDayOfWeek(); wd.length < 7; index++) {
        if (index === 7) {
          index = 0
        }
        wd.push(index)
      }
      return wd
    },
    table () {
      return this.weekdays.map((day) => {
        if (this.timetable.some((t) => { return t.day === day })) {
          var item = this.timetable.find((t) => { return t.day === day })
          return {
            day: day,
            current: item.current,
            hours: item.hours,
          }
        } else {
          return {
            day: day,
            current: null,
            hours: [],
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
